var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.urgencia)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({class:("icon " + _vm.textColorClass)},on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}],null,false,2431102875)},[_c('span',[_vm._v(_vm._s(_vm.description))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }